'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var Panel = function Panel(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      style = _ref.style,
      children = _ref.children,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$renderRight = _ref.renderRight,
      renderRight = _ref$renderRight === undefined ? function () {
    return null;
  } : _ref$renderRight,
      others = _objectWithoutProperties(_ref, ['className', 'style', 'children', 'title', 'renderRight']);

  var classNames = (0, _classnames2.default)('a-panel', className);

  return React.createElement(
    'div',
    Object.assign({ className: classNames, style: style }, others),
    title && React.createElement(
      'div',
      { className: 'a-panel-header' },
      React.createElement(
        'span',
        { className: 'a-panel-title' },
        title
      ),
      React.createElement(
        'div',
        { className: 'a-panel-header-right' },
        renderRight()
      )
    ),
    React.createElement(
      'div',
      { className: 'a-panel-content' },
      children
    )
  );
};

Panel.propTypes = Object.assign({}, {
  children: require('prop-types').node.isRequired
}, babelPluginFlowReactPropTypes_proptype_CommonType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_CommonType);
Panel.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

exports.default = Panel;